import React from 'react';
import {withTranslation} from "react-i18next";
import ToOverviewComponent from "./ToOverviewComponent";

let vouchersNotFound = ({t}) => {
	return <div>
		<p>{t('reward.claim.vouchers.notFound')}</p>
		<ToOverviewComponent/>
	</div>
};

export default withTranslation() (vouchersNotFound)